document.addEventListener("DOMContentLoaded", () => {

    const kachingData = JSON.parse(
        document.querySelector('.kaching-bundles-product')?.innerText || "{}"
    );

    function getGemSelection() {
        return {
            color: document.querySelector('[option-name="Color"] legend span')?.innerText.trim(),
            model: document.querySelector('[option-name="Model"] legend span')?.innerText.trim(),
        };
    }

    function findVariant(color, model) {
        return kachingData.variants.find(v =>
            v.options[0] === color && v.options[1] === model
        );
    }

    function syncKaching() {
        const sel = getGemSelection();
        if (!sel.color || !sel.model) return;

        const variant = findVariant(sel.color, sel.model);
        if (!variant) return;

        // Update Kaching internal variant selection
        document.querySelectorAll(".kaching-bundles__bar-variant-selects")
            .forEach(group => {
                group.dataset.option = `${sel.model}-${sel.color}`;
            });

        // Trigger Kaching to rebuild UI properly
        if (window.KachingBundles?.refreshAll) {
            window.KachingBundles.refreshAll();
        }
    }

    // When GemPages variant is changed
    document.addEventListener("change", e => {
        if (e.target.matches('[name*="options-"]')) {
            setTimeout(syncKaching, 80);
        }
    });

    setTimeout(syncKaching, 400);
});
